import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function Forbidden() {
    const navigate = useNavigate();

    return (
        <Box
            sx={{
                height: "100vh",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: 2
            }}
        >
            <Typography variant="h4">403</Typography>
            <Typography>No tienes permiso para acceder a este módulo</Typography>
            <Button variant="contained" onClick={() => navigate("/")}>
                Volver
            </Button>
        </Box>
    );
}
